import styled, { css, keyframes } from 'styled-components'
import { FilterIcon, ChevronIcon, LocationIcon } from '@sainsburys-tech/bolt-icons'

export const ListerTools = styled.div`
	display: flex;
	flex-wrap: wrap;
	transition: opacity 0.1s ease-out;
	position: sticky;
	top: ${({ offset }) => (offset ? `${offset}px` : 0)};
	left: 0;
	z-index: 4;
	opacity: 1;
	border: 1px solid ${props => props.theme.tokens.color.monochrome.light};
	border-width: 1px 0;
	align-items: center;
	justify-content: space-between;
	visibility: visible;
	background-color: ${props => props.theme.tokens.color.monochrome.white};

	${props =>
    props.hidden &&
    css`
      opacity: 0;
    `}

	@media (max-width: ${props => props.theme.screen_sm_max}) {
		box-shadow: 0 4px 4px -4px rgba(0, 0, 0, 0.3);
	}

	@media only screen and (min-width: ${props => props.theme.screen_sm_min}) {
		position: inherit;
		opacity: 1;
	}
	@media only screen and (min-width: ${props => props.theme.screen_md_min}) {
		border-width: 1px 0 0;
	}

`

export const FilterButton = styled.button`
  width: 100%;
  border-right: 1px solid ${props => props.theme.tokens.color.monochrome.light};
  border-width: 0 1px 0 0;
  height: 46px;
  line-height: 20px;
  text-align: left;
  padding: 10px 15px;
  text-transform: none;
  border-radius: 0;
  position: relative;
  background-color: ${props => props.theme.tokens.color.monochrome.white};

  @media (min-width: ${props => props.theme.screen_md_min}) {
    height: 42px;
    padding: 11px 10px;
    line-height: 16px;
  }
`

export const FilterButtonLabel = styled.span`
  color: ${props => props.theme.tokens.color.palette.brand3};
  margin-right: 10px;
  font-size: ${props => props.theme.tokens.typography.fontSize.root};
  font-family: ${props => props.theme.tokens.typography.base.fontFamily};
  float: left;

  /* Really obsure edge-case for item counts with 4 chars */
  @media screen and (max-width: 340px) {
    margin-right: 5px;
  }
`

export const FilterButtonCount = styled.i`
  font-size: 14px;
  color: ${props => props.theme.tokens.color.monochrome.dark};
  float: left;
`

export const FilterButtonIcon = styled(FilterIcon)`
  color: ${props => props.theme.tokens.color.palette.blueDark};
  float: right;
  height: 19px;
  font-size: 18px;
`

export const ResultsCount = styled.span`
  transition: opacity 0.25s ease-out;
  text-align: center;
  padding: 10px;
  color: ${props => props.theme.tokens.color.monochrome.dark};
  width: 100%;
  left: 0;
  visibility: visible;
  opacity: 1;
  line-height: ${props => props.theme.line_height_base};
  background-color: ${props => props.theme.tokens.color.monochrome.white};
  height: 46px;
  border-top: 1px solid ${props => props.theme.tokens.color.monochrome.light};

  ${props =>
    props.availabilityEnabled &&
    css`
      @media only screen and (min-width: ${props.theme.screen_md_min}) {
        text-align: right;
      }
    `}

    ${props =>
      !props.isDesktop &&
      css`
        @media only screen and (min-width: ${props.theme.screen_lg_min}) {
          text-align: center;
        }
      `}


  ${props =>
    props.isDesktop &&
    css`
      text-align: left;
      border-top: none;
    `}
`

export const SortPanel = styled.label`
  display: flex;
  width: 100%;
  position: relative;
`

export const SortSelectWrapper = styled.div`
  width: 100%;

  @media only screen and (min-width: ${props => props.theme.screen_lg_min}) {
    margin-left: 15px;
  }
`

export const SortBy = styled.span`
  display: none;

  @media only screen and (min-width: ${props => props.theme.screen_lg_min}) {
    line-height: 42px;
    display: inline-block;
    height: 42px;
    color: ${props => props.theme.tokens.color.monochrome.dark};
    text-align: right;
    white-space: nowrap;
    padding: 0;
    &::after {
      content: '';
      border-right: 1px solid ${props => props.theme.tokens.color.monochrome.light};
      bottom: 10px;
      padding-left: 10px;
      height: 24px;
    }
  }
`

export const SortIcon = styled(ChevronIcon)`
  position: absolute;
  top: 13px;
  right: 15px;
  color: ${props => props.theme.tokens.color.palette.blueDark};
  font-size: 16px;
  line-height: 16px;
  pointer-events: none;
  @media only screen and (min-width: ${props => props.theme.screen_md_min}) {
    top: 10px;
    right: 10px;
  }
`

export const SortSelect = styled.select`
  color: ${props => props.theme.tokens.color.palette.brand3};
  border: none;
  height: 46px;
  margin: 0;
  text-align: left;
  width: 100%;
  appearance: none;
  border-radius: 0;
  background-color: ${props => props.theme.tokens.color.monochrome.white};
  font-size: ${props => props.theme.tokens.typography.fontSize.root};
  font-family: ${props => props.theme.tokens.typography.base.fontFamily};
  cursor: pointer;

  &::-ms-expand {
    display: none;
  }

  @media only screen and (min-width: ${props => props.theme.screen_md_min}) {
    height: 42px;
    line-height: 23px;
  }
  @media only screen and (min-width: ${props => props.theme.screen_lg_min}) {
    font-weight: 600;
  }
`

const flickerAnimation = keyframes`
	40% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	60% {
		opacity: 1;
	}
	100% {
		opacity: 1;
	}
`

export const ListerMeta = styled.div`
  color: ${props => props.theme.tokens.color.palette.green};
  text-align: center;
  padding: 10px 0;
  opacity: 1;
  animation: ${flickerAnimation} 5s infinite;
`

export const Localisation = styled.div`
  width: 100%;
  height: 46px;
  line-height: ${props => props.theme.line_height_base};
  text-align: center;
  padding: 10px;

  ${props =>
    !props.isDesktop &&
    css`
      border-top: 1px solid ${props.theme.tokens.color.monochrome.light};
    `}

  @media only screen and (min-width: ${props => props.theme.screen_md_min}) {
    text-align: left;
  }


`

export const LoadingLocalisation = styled(Localisation)`
  & svg {
    vertical-align: middle;
    width: 276px;
  }
`

export const LocalisationIcon = styled(LocationIcon)`
  margin-right: 5px;
  vertical-align: middle;
  height: 1.3em;
  width: 1.3em;
`
